import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveProvider } from "./retrieve-provider";
import type { AdminProviderVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";

const initialState: RetrievalState<Nullable<AdminProviderVM>> = { fetching: "idle", data: null };

export const retrieveProviderReducer = createReducer<RetrievalState<Nullable<AdminProviderVM>>>(initialState, builder => {
  builder.addCase(retrieveProvider.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveProvider.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveProvider.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
